import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { slugs } from "../../../Constant/slugs";
import { AdsGETApiAuth } from "../../../Constant/api";
import { CSVLink } from "react-csv";



export default function AllRegistrationForm() {
  const [Projects1, setProjects1] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [Reload, setReload] = React.useState(false)
  const [CustomersDownload, setCustomersDownload] = React.useState([])
  const [showModal, setshowModal] = React.useState(false)
  const [ThisStudent, setThisStudent] = React.useState({})
  const [DateAttendence, setDateAttendence] = React.useState("")

  const GetAllProjects = (params) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth(params, "big_form")
      .then((res) => {
        setProjects1(res.data)
        setCustomersList(res.data)
        sortForDownload(res.data)
        console.log("done")
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  useEffect(() => {
    GetAllProjects({
      per_page: 100,
      _fields: "id,title,slug,meta,date"
    })

  }, [])
  var date = new Date()
  var today = date.toLocaleDateString()
  const isoToDmy = (iso) => {
    if (!iso) return "";
    console.log(iso)
    const [y, m, d] = iso.split("-");
    return `${y}-${m}-${d}`; // DD/MM/YYYY
  };
  const isoToDmyNumber = (iso) => {
    if (!iso) return "";
    console.log(iso)
    const [y, m, d] = iso.split("-");
    return `${Number(m)}/${d}/${y}`; // DD/MM/YYYY
  };

  const dmyToIso = (dmy) => {
    if (!dmy) return "";
    const [d, m, y] = dmy.split("/");
    const dd = String(d).padStart(2, "0");
    const mm = String(m).padStart(2, "0");
    return `${y}-${mm}-${dd}`; // YYYY-MM-DD
  };
  // const inputValueISO = useMemo(() => dmyToIso(dateDMY), [dateDMY]);

  const handleChange = (e) => {
    const iso = e.target.value       // "YYYY-MM-DD"
    const dmy = isoToDmy(iso);           // "DD/MM/YYYY"
    const dmy2 = isoToDmyNumber(iso);
    console.log("await", dmy, dmy2)
    setDateAttendence(iso)
    console.log(CustomersList, dmy, dmy2, iso)
    var newdata = CustomersList.filter(a => a.date.includes(dmy) || a.date.includes(dmy2))
    setProjects1(newdata)
    sortForDownload(newdata)
    // setDateDMY(dmy);                     // ✅ set on change
  };

  const sortForDownload = (DataArray) => {
    var dData = []
    for (let i = 0; i < DataArray.length; i++) {
      var item = DataArray[i]
      dData.push({
        id: item.id,
        "student_name": item.meta.student_name,
        "address": item.meta.address,
        "mobile_number": item.meta.mobile_number,
        "alternate_mobile_number": item.meta.alternate_mobile_number,
        "date_of_birth": item.meta.date_of_birth,
        "gender": item.meta.gender,
        "category": item.meta.category,
        "academics_recent": item.meta.academics_recent,
        "passed_year": item.meta.passed_year,
        "gpa_percent": item.meta.gpa_percent,
        "interested_country": item.meta.interested_country,
        "course": item.meta.course,
        "email": item.meta.email,
        "remarks": item.meta.remarks,
      })
    }
    setCustomersDownload(dData)
    console.log("done", dData)
  }
  const headers = [
    { label: "Name", key: "student_name" },
    { label: "Address", key: "address" },
    { label: "Phone Number", key: "mobile_number" },
    { label: "Alternative Phone Number", key: "alternate_mobile_number" },
    { label: "Email", key: "email" },
    { label: "Date of Birth", key: "date_of_birth" },
    { label: "Gender", key: "gender" },
    { label: "Category", key: "category" },
    { label: "Academics Recent", key: "academics_recent" },
    { label: "Passed Year", key: "passed_year" },
    { label: "GPA/Percent", key: "gpa_percent" },
    { label: "Interested Country", key: "interested_country" },
    { label: "Course", key: "course" },
    { label: "Remarks", key: "remarks" },
    { label: "Date", key: "date" },
  ];


  const columns = [
    {
      id: 1,
      name: "id",
      selector: (row) => row.id,
      sortable: true,
      reorder: true,
    },
    {
      id: 2,
      name: "Name",
      selector: (row) => row.meta.student_name,
      sortable: true,
      reorder: true
    },
    {
      id: 3,
      name: "Phone",
      selector: (row) => row.meta.mobile_number,
      sortable: true,
      reorder: true
    },

    {
      id: 4,
      name: "Gender",
      selector: (row) => row.meta.gender,
      sortable: true,
      reorder: true
    },
    {
      id: 5,
      name: "Category",
      selector: (row) => row.meta.category,
      sortable: true,
      reorder: true
    },
    {
      id: 6,
      name: "Qualification",
      selector: (row) => row.meta.academics_recent,
      sortable: true,
      reorder: true
    },
    {
      id: 7,
      name: "Date",
      selector: (row) => row.date.slice(0, 10),
      sortable: true,
      reorder: true
    },
     {
      id: 9,
      name: "Whatsapp",
      right: true,
      cell: (row) => <a target="_blank" href={`https://wa.me/977${row.meta.mobile_number}`}>Whatsapp</a>,

    },
    {
      id: 8,
      name: "View",
      right: true,
      cell: (row) => <div onClick={() => {
        setshowModal(true)
        setThisStudent(row)
      }}>View</div>,

    }
  ];
  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>General Form</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Batches
        </div>
      </div>
      <div style={{ display: "inline-block" }}>
        <input
          type="date"
          onChange={handleChange}
        />
      </div>

      <div style={{ display: "inline-block", margin: "0px 5px", cursor: "pointer" }}>
        <CSVLink data={CustomersDownload} headers={headers} className="Link"
          filename={`StudentData-${date.toLocaleString()}.csv`}
        >

          Download Excel
        </CSVLink>
      </div>
      <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px" }}>
        <DataTable
          columns={columns}
          data={Projects1}
          defaultSortFieldId={1}
          defaultSortAsc={false}
          striped
          // sortIcon={<SortIcon />}
          pagination
          selectableRows
        />
      </div>
      {Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }

      {showModal &&
        <section className="modal" style={{ overflowX: 'hidden', }}>
          <div className="row" style={{ overflowX: 'hidden', }}>
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white" style={{ borderRadius: "10px", }}>
              <div style={{ margin: " 10px", overflowX: 'hidden', padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setshowModal(false)
                    setThisStudent({})
                  }}
                >X</div>
              </div>

              <div class="admin-registration-modal-body">



                <div class="admin-detail-section">


                  <div class="admin-detail-section-title">

                    <div>
                      <i class="fa-solid fa-user"></i>
                    </div>

                    <div>
                      <span>01</span>
                      <h3>Personal Information</h3>
                    </div>

                  </div>



                  <div class="admin-details-grid">


                    <div class="admin-detail-item">

                      <span>Student Name</span>

                      <strong>
                        {ThisStudent.meta.student_name}
                      </strong>

                    </div>


                    <div class="admin-detail-item">

                      <span>Gender</span>

                      <strong>
                        {ThisStudent.meta.gender}
                      </strong>

                    </div>


                    <div class="admin-detail-item">

                      <span>Date of Birth</span>

                      <strong>
                        {ThisStudent.meta.date_of_birth}
                      </strong>

                    </div>


                    <div class="admin-detail-item">

                      <span>Category</span>

                      <strong>
                        {ThisStudent.meta.category}
                      </strong>

                    </div>


                    <div class="admin-detail-item full-width">

                      <span>Address</span>

                      <strong>
                        {ThisStudent.meta.address}
                      </strong>

                    </div>


                  </div>

                </div>




                <div class="admin-detail-section">


                  <div class="admin-detail-section-title">

                    <div>
                      <i class="fa-solid fa-address-book"></i>
                    </div>

                    <div>
                      <span>02</span>
                      <h3>Contact Information</h3>
                    </div>

                  </div>



                  <div class="admin-details-grid">


                    <div class="admin-detail-item">

                      <span>Mobile Number</span>

                      <strong>
                        {ThisStudent.meta.mobile_number}
                      </strong>

                    </div>


                    <div class="admin-detail-item">

                      <span>Alternate Mobile</span>

                      <strong>
                        {ThisStudent.meta.alternate_mobile_number}
                      </strong>

                    </div>


                    <div class="admin-detail-item full-width">

                      <span>Email Address</span>

                      <strong>
                        {ThisStudent.meta.email}
                      </strong>

                    </div>


                  </div>

                </div>



                <div class="admin-detail-section">


                  <div class="admin-detail-section-title">

                    <div>
                      <i class="fa-solid fa-graduation-cap"></i>
                    </div>

                    <div>
                      <span>03</span>
                      <h3>Academic Information</h3>
                    </div>

                  </div>



                  <div class="admin-details-grid">


                    <div class="admin-detail-item">

                      <span>Recent Academic</span>

                      <strong>
                        {ThisStudent.meta.academics_recent}
                      </strong>

                    </div>


                    <div class="admin-detail-item">

                      <span>Passed Year</span>

                      <strong>
                        {ThisStudent.meta.passed_year}
                      </strong>

                    </div>


                    <div class="admin-detail-item">

                      <span>GPA / Percentage</span>

                      <strong>
                        {ThisStudent.meta.gpa_percent}
                      </strong>

                    </div>


                    {/* <div class="admin-detail-item">

                      <span>Category</span>

                      <strong>
                        Graduate
                      </strong>

                    </div> */}
                  </div>
                </div>


                <div class="admin-detail-section">


                  <div class="admin-detail-section-title">

                    <div>
                      <i class="fa-solid fa-earth-asia"></i>
                    </div>

                    <div>
                      <span>04</span>
                      <h3>Study Preference</h3>
                    </div>

                  </div>



                  <div class="admin-details-grid">


                    <div class="admin-detail-item">

                      <span>Interested Country</span>

                      <strong class="admin-highlight-value">
                        {ThisStudent.meta.interested_country}
                      </strong>

                    </div>


                    <div class="admin-detail-item">

                      <span>Course / Program</span>

                      <strong>
                        {ThisStudent.meta.course}
                      </strong>

                    </div>


                  </div>

                </div>

                <div class="admin-detail-section">


                  <div class="admin-detail-section-title">

                    <div>
                      <i class="fa-solid fa-message"></i>
                    </div>

                    <div>
                      <span>05</span>
                      <h3>Remarks</h3>
                    </div>

                  </div>


                  <div class="admin-registration-remarks">
                    {ThisStudent.meta.remarks}


                  </div>

                </div>

              </div>




              <div class="admin-registration-modal-footer">

                <button
                  type="button"
                  class="admin-modal-secondary admin-modal-close"
                  onClick={() => {
                    setshowModal(false)
                    setThisStudent({})
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </section>
      }
    </div>
  )
}